"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Icon_1 = require("../Icon");
const Tooltip_1 = require("../Tooltip");
const Css_1 = require("../../Css");
const utils_1 = require("../../utils");
function Avatar({ src, name, size = "md", showName = false, disableTooltip = false, ...others }) {
    const tid = (0, utils_1.useTestIds)(others, "avatar");
    const px = sizeToPixel[size];
    const [showFallback, setShowFallback] = (0, react_1.useState)(src === undefined);
    // Define min-width as well as width to prevent the image from shrinking when displayed within a flex-child that allows shrinking.
    const styles = Css_1.Css.br100.wPx(px).hPx(px).mwPx(px).overflowHidden.$;
    const img = showFallback ? ((0, jsx_runtime_1.jsx)("div", { css: { ...styles, ...Css_1.Css[sizeToFallbackTypeScale[size]].bgGray400.gray100.df.aic.jcc.$ }, ...tid, children: name ? nameToInitials(name) : (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "userCircle", inc: sizeToIconInc[size] }) })) : ((0, jsx_runtime_1.jsx)("img", { src: src, alt: name, css: { ...styles, ...Css_1.Css.objectCover.$ }, onError: () => setShowFallback(true), loading: "lazy", ...tid }));
    return showName && name ? ((0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.dif.aic.gap1.if(size === "lg" || size === "xl").fdc.$, children: [img, (0, jsx_runtime_1.jsx)("span", { css: Css_1.Css[sizeToTypeScale[size]].$, children: name })] })) : ((0, Tooltip_1.maybeTooltip)({ title: disableTooltip ? undefined : name, children: img, placement: "top" }));
}
exports.Avatar = Avatar;
const sizeToPixel = {
    sm: 24,
    md: 36,
    lg: 48,
    xl: 72,
};
const sizeToFallbackTypeScale = {
    sm: "tiny",
    md: "sm",
    lg: "lg",
    xl: "xl3",
};
const sizeToIconInc = {
    sm: 2.5,
    md: 4,
    lg: 5,
    xl: 8,
};
const sizeToTypeScale = {
    sm: "smMd",
    md: "smMd",
    lg: "base",
    xl: "base",
};
function nameToInitials(name) {
    return (name
        .split(" ")
        .map((n) => (n.length > 0 ? n[0].toUpperCase() : ""))
        .join("")
        // Return at most 3 initials
        .slice(0, 3));
}
